import { type ChangeEvent } from 'react';

import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';
import { TextInput } from '@hivebrite/design-system/Inputs';

import { DateRangeInput } from 'hb-react/frontoffice/apps/NewsIndex/components/DateRangeInput';
import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

import { type DateRangeArgs, type TextInputArgs } from './types';

const SearchIcon = () => (
  <FontAwesomeIcon height="16px" iconName="magnifying-glass" />
);

const createFilters = (fulltextId: string, dateRangeId: string) => [
  {
    component: ({ id, onChange, value }: TextInputArgs) => (
      <TextInput
        clearable
        icon={SearchIcon}
        id={id}
        label={s__('News|Search by keyword')}
        labelMultiline
        name={id}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value)
        }
        placeholder={__('Type name or keyword')}
        value={value ?? ''}
      />
    ),
    id: fulltextId,
  },
  {
    component: ({ id, onChange, value }: DateRangeArgs) => (
      <DateRangeInput
        fromInputProps={{
          ariaLabel: s__('Accessibility|Filter from published date'),
          id: `${id}_from`,
          name: `${id}_from`,
          onChange: (date: string) => {
            if (
              (value?.from === '' || value?.from === undefined) &&
              (!date || date === '')
            ) {
              return;
            }

            if ((!date || date === '') && (!value?.to || value?.to === '')) {
              onChange({});

              return;
            }

            onChange({ ...value, from: date });
          },
          value: value?.from ?? '',
          variant: 'normal',
        }}
        id={id}
        label={s__('News|Publication date (From - To)')}
        sharedInputProps={{
          clearable: true,
          displayFormat: I18n.t('date.formats.alt_format'),
        }}
        toInputProps={{
          ariaLabel: s__('Accessibility|Filter to published date'),
          id: `${id}_to`,
          name: `${id}_to`,
          onChange: (date: string) => {
            if (
              (value?.to === '' || value?.to === undefined) &&
              (!date || date === '')
            ) {
              return;
            }

            if (
              (!date || date === '') &&
              (!value?.from || value?.from === '')
            ) {
              onChange({});

              return;
            }

            onChange({
              ...value,
              to: date
                ? dayjs(date).add(1, 'day').subtract(1, 'minute').format()
                : null,
            });
          },
          value: value?.to ?? '',
          variant: 'normal',
        }}
      />
    ),
    id: dateRangeId,
  },
];

export const filtersOld = createFilters('fulltext', 'feedable');

export const filtersNew = createFilters('full_text', 'published_at');
